import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

export default class BarGraphTRS extends React.Component {
    static propTypes = {
        metrics: PropTypes.array,
        categories: PropTypes.array,
        flowType: PropTypes.string,
    };

    barColor = score => {
        const flowType = this.props.flowType;

        if (typeof score === 'object' || Number.isNaN(score)) {
            return style.barDefault;
        }

        // OWBI-specific values
        if (flowType && flowType.includes('owbi')) {
            if (score < 1) {
                return style.barGray;
            }
            if (score < 2) {
                return style.barRed;
            }
            if (score < 3) {
                return style.barYellow;
            }
            if (score >= 3) {
                return style.barGreen;
            }
        }

        if (score <= 1) {
            return style.barRed;
        }
        if (score > 1 && score <= 3) {
            return style.barYellow;
        }
        if (score > 3 && score < 5) {
            return style.barGreen;
        }
        if (score > 5) {
            return style.barDefault;
        }
        return style.scoreZero;
    };

    getBarText = score => {
        if (typeof score === 'object' || Number.isNaN(score)) {
            return `Don't know/Prefer not to respond`;
        }
        if (score === 777) {
            return `Don't know`;
        }
        if (score === 888) {
            return `Prefer not to respond`;
        }
        if (!Number.isFinite(score)) {
            return '';
        }

        return score;
    };

    getBarWidth = score => {
        const max = 4;
        if (typeof score === 'object' || Number.isNaN(score)) {
            return { width: '100%' };
        }
        return { width: `${(score / max) * 100}%` };
    };

    render() {
        const { metrics, categories } = this.props;
        return (
            <div className={style.barGraph}>
                <div className={style.barScale}>
                    <div className={style.scaleTop}>
                        <div className={style.scaleTopLeft} />
                        <div className={style.scaleTopRight} />
                    </div>
                    <div className={style.scaleBottom} />
                </div>
                {categories && categories.length > 0
                    ? categories.map(category => {
                          const cg = metrics.filter(metric => metric.category === category.handle);
                          return (
                              <div key={category.title}>
                                  <h5>{category.title}</h5>
                                  {cg &&
                                      cg.map(obj => {
                                          return (
                                              <div style={{ display: 'flex', alignItems: 'center' }} key={obj.title}>
                                                  <div className={style.barBg}>
                                                      <div
                                                          className={style.score + ' ' + this.barColor(obj.score)}
                                                          style={this.getBarWidth(obj.score)}
                                                      >
                                                          {this.getBarText(obj.score)}
                                                      </div>
                                                  </div>
                                                  <div>
                                                      <p>{obj.title}</p>
                                                  </div>
                                              </div>
                                          );
                                      })}
                              </div>
                          );
                      })
                    : metrics.map(metric => (
                          <div style={{ display: 'flex', alignItems: 'center' }} key={metric.title}>
                              <div className={style.barBg}>
                                  <div
                                      className={style.score + ' ' + this.barColor(metric.score)}
                                      style={this.getBarWidth(metric.score)}
                                  >
                                      {this.getBarText(metric.score)}
                                  </div>
                              </div>
                              <div>
                                  <p>{metric.title}</p>
                              </div>
                          </div>
                      ))}
            </div>
        );
    }
}
